import {
  getDashboardConfig,
  getCaseInvestigationDetails,
  createNewCaseInvestigation,
  getAllCaseInvestigations, updateCaseInvestigationStatusByCaseId, addCaseInvestigationNoteInvestigationByCaseId
} from '@store/actions/caseInvestigationManagerActions';
import { CASE_INVESTIGATION_STATUS } from '@views/CaseInvestigationManager/constant';
import { SORT_ORDER } from '@constants';
import { FIELD_SIZE, INPUT_FIELD_TYPE, INPUT_TYPE } from '@components/DynamicFormField/constant';


export const caseInvestigationManagerConfigBuilder = () => {
  return {
    searches : [
      {
        display: "Case Id",
        searchKey: "caseId",
        placeholder: "Search By Case ID",
        isDefault: true
      },
      {
        display: "Order ID",
        searchKey: "orderId",
        placeholder: "Search by Order ID",
        isDefault: false
      }
    ],
    filters: [
      {
        title: "Case Statuses",
        key: "statuses",
        filters: Object.keys(CASE_INVESTIGATION_STATUS)
      },
    ],
    sorting: {
      defaultSortKey: "createdAt",
      defaultSortValue: SORT_ORDER.DESC,
      options: [
        {
          key: "created_at",
          display: "Created Date",
          values: Object.keys(SORT_ORDER)
        }
      ]
    }
  }
}

/**
 * Case Investigation Manager Config
 */
export const caseInvestigationManagerConfig = {
  id: 'caseInvestigationManagerConfig',
  actions: {
    getDashboardConfig:() => getDashboardConfig(),
    fieldsGroupBuilder: () => buildCreateCaseInvestigationFieldsGroup(),
    getAllCaseInvestigations: ({ payload, onSuccess, onComplete }) => getAllCaseInvestigations({payload, onSuccess, onComplete}),
    createNewCaseInvestigation: ({ payload, onSuccess, onComplete }) => createNewCaseInvestigation({payload, onSuccess, onComplete}),
    getCaseInvestigationDetails: ({ caseId, onSuccess, onComplete }) => getCaseInvestigationDetails({caseId, onSuccess, onComplete}),
    updateCaseInvestigationStatusByCaseId: ({ caseGuid, status, onSuccess, onComplete }) => updateCaseInvestigationStatusByCaseId({ caseGuid, status, onSuccess, onComplete}),
    addCaseInvestigationNoteInvestigationByCaseId: ({ caseGuid, payload, onSuccess, onComplete }) => addCaseInvestigationNoteInvestigationByCaseId({ caseGuid, payload, onSuccess, onComplete}),
  }
};


export const CASE_INVESTIGATION_CREATE_ENUMS = {
  CLASSIFICATION: [
    { key: 'ACCOUNT_TAKEOVER', value: 'ACCOUNT_TAKEOVER', label: 'Account Takeover' },
    { key: 'LOST_OR_STOLEN_DEVICE', value: 'LOST_OR_STOLEN_DEVICE', label: 'Lost Or Stolen Device' },
    { key: 'SIM_SWAP_ATTACK', value: 'SIM_SWAP_ATTACK', label: 'Sim Swap Attack' },
    { key: 'STOLEN_PAYMENT_INSTRUMENT', value: 'STOLEN_PAYMENT_INSTRUMENT', label: 'Stolen Payment Instrument' },
    { key: 'FRIENDLY_FRAUD', value: 'FRIENDLY_FRAUD', label: 'Friendly Fraud' },
    { key: 'SYNTHETIC_ID_FRAUD', value: 'SYNTHETIC_ID_FRAUD', label: 'Synthetic Id Fraud' },
    { key: 'BUST_OUT', value: 'BUST_OUT', label: 'Bust Out' },
    { key: 'CARD_TESTING', value: 'CARD_TESTING', label: 'Card Testing' },
    { key: 'REFERRAL_PROGRAM_ABUSE', value: 'REFERRAL_PROGRAM_ABUSE', label: 'Referral Program Abuse' },
    { key: 'PROMOTIONAL_ABUSE', value: 'PROMOTIONAL_ABUSE', label: 'Promotional Abuse' },
    { key: 'MONEY_MULE_ACTIVITY', value: 'MONEY_MULE_ACTIVITY', label: 'Money Mule Activity' },
    { key: 'TERMS_OF_SERVICE_VIOLATION', value: 'TERMS_OF_SERVICE_VIOLATION', label: 'Terms Of Service Violation' }
  ],
  TRIGGER_TYPE: [
    { key: 'AUTOMATED_RULE', value: 'AUTOMATED_RULE', label: 'Automated Rule' },
    { key: 'CUSTOMER_REPORT', value: 'CUSTOMER_REPORT', label: 'Customer Report' },
    { key: 'PARTNER_ALERT', value: 'PARTNER_ALERT', label: 'Partner Alert' },
    { key: 'EMPLOYEE_REPORT', value: 'EMPLOYEE_REPORT', label: 'Employee Report' },
    { key: 'EXTERNAL_PERSON_REPORT', value: 'EXTERNAL_PERSON_REPORT', label: 'External Person Report' }
  ],
  PRIORITY: [
    { key: 'LOW', value: 'LOW', label: 'Low' },
    { key: 'MEDIUM', value: 'MEDIUM', label: 'Medium' },
    { key: 'HIGH', value: 'HIGH', label: 'High' },
    { key: 'CRITICAL', value: 'CRITICAL', label: 'Critical' }
  ],
  REVERSAL_STATUS: [
    { key: 'PENDING_INTERNAL_REVIEW', value: 'PENDING_INTERNAL_REVIEW', label: 'Pending Internal Review' },
    { key: 'REVERSAL_INITIATED', value: 'REVERSAL_INITIATED', label: 'Reversal Initiated' },
    { key: 'DISPUTE_IN_PROGRESS', value: 'DISPUTE_IN_PROGRESS', label: 'Dispute In Progress' },
    { key: 'EVIDENCE_SUBMITTED', value: 'EVIDENCE_SUBMITTED', label: 'Evidence Submitted' },
    { key: 'REVERSED_FULL', value: 'REVERSED_FULL', label: 'Fully Reversed' },
    { key: 'REVERSED_PARTIAL', value: 'REVERSED_PARTIAL', label: 'Partially Reversed' },
    { key: 'REVERSED_NO_LOSS', value: 'REVERSED_NO_LOSS', label: 'Reversed - No Loss' },
    { key: 'REVERSAL_NOT_POSSIBLE', value: 'REVERSAL_NOT_POSSIBLE', label: 'Reversal Not Possible' },
    { key: 'CANCELLED', value: 'CANCELLED', label: 'Cancelled' },
  ]
};

export const buildCreateCaseInvestigationFieldsGroup = () => {
  return {
    Case: [
      {
        key: 'classification',
        name: 'classification',
        value: null,
        label: 'Classification',
        caption: null,
        fieldType: INPUT_FIELD_TYPE.SELECT,
        fieldSize: FIELD_SIZE.MEDIUM,
        placeholder: 'Select Classification',
        options: CASE_INVESTIGATION_CREATE_ENUMS.CLASSIFICATION.map((o) => ({
          key: o.key,
          value: o.value,
          label: o.label
        })),
        isEditable: true,
        isRequired: true
      },
      {
        key: 'triggerType',
        name: 'triggerType',
        value: null,
        label: 'Trigger Type',
        caption: null,
        fieldType: INPUT_FIELD_TYPE.SELECT,
        fieldSize: FIELD_SIZE.MEDIUM,
        placeholder: 'Select Trigger Type',
        options: CASE_INVESTIGATION_CREATE_ENUMS.TRIGGER_TYPE.map((o) => ({
          key: o.key,
          value: o.value,
          label: o.label
        })),
        isEditable: true,
        isRequired: true
      },
      {
        key: 'triggerPartner',
        name: 'triggerPartner',
        value: '',
        label: 'Partner Name',
        caption: null,
        fieldType: INPUT_FIELD_TYPE.INPUT,
        inputType: INPUT_TYPE.STRING,
        fieldSize: FIELD_SIZE.MEDIUM,
        placeholder: 'Enter Partner Name',
        isEditable: true,
        isRequired: false,
        dependsOn: {
          field: 'triggerType',
          value: 'PARTNER_ALERT'
        }
      },
      {
        key: 'priority',
        name: 'priority',
        value: 'MEDIUM',
        label: 'Priority',
        caption: null,
        fieldType: INPUT_FIELD_TYPE.SELECT,
        fieldSize: FIELD_SIZE.MEDIUM,
        placeholder: 'Select Priority',
        options: CASE_INVESTIGATION_CREATE_ENUMS.PRIORITY.map((o) => ({
          key: o.key,
          value: o.value,
          label: o.label
        })),
        isEditable: true,
        isRequired: true
      },
      {
        key: 'incidentDate',
        name: 'incidentDate',
        value: '',
        label: 'Incident Date',
        caption: null,
        placeholder: 'Select a date',
        fieldType: INPUT_FIELD_TYPE.INPUT,
        inputType: INPUT_TYPE.DATE,
        fieldSize: FIELD_SIZE.MEDIUM,
        width: 'auto',
        isEditable: true,
        isRequired: true
      },
      {
        key: 'summary',
        name: 'summary',
        value: '',
        label: 'Summary',
        caption: null,
        placeholder: 'Add a short summary (max 500 chars)',
        fieldType: INPUT_FIELD_TYPE.TEXTAREA,
        inputType: INPUT_TYPE.STRING,
        fieldSize: FIELD_SIZE.LARGE,
        width: 'auto',
        isEditable: true,
        isRequired: true,
        maxLength: 500
      }
    ]
  };
};

// ---------------------- Create Modal Per-section Field Configs ----------------------

export const peopleInvolvedFieldConfig = {
  roleOptions: [
    { key: 'VICTIM', value: 'VICTIM', label: 'Victim' },
    { key: 'SUSPECT', value: 'SUSPECT', label: 'Suspect' }
  ],
  buildSelectedPersonFields: (person) => [
    {
      key: `personName`,
      name: 'personName',
      value: person?.name || '',
      label: 'Full Name',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: `personEmail`,
      name: 'personEmail',
      value: person?.email || '',
      label: 'Email',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: `personRole`,
      name: 'personRole',
      value: person?.role || 'VICTIM',
      label: 'Type',
      fieldType: INPUT_FIELD_TYPE.SELECT,
      options: [
        { key: 'VICTIM', value: 'VICTIM', label: 'Victim' },
        { key: 'SUSPECT', value: 'SUSPECT', label: 'Suspect' }
      ],
      isEditable: true,
      placeholder: 'Select type'
    }
  ],
  externalUserFields: [
    {
      key: 'extFullName',
      name: 'extFullName',
      value: '',
      label: 'Full Name',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: true,
      placeholder: 'Full name',
      isRequired: true
    },
    {
      key: 'extContact',
      name: 'extContact',
      value: '',
      label: 'Contact Number',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.TEL,
      isEditable: true,
      placeholder: 'Contact number (optional)',
      isRequired: false
    },
    {
      key: 'extEmail',
      name: 'extEmail',
      value: '',
      label: 'Email',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.EMAIL,
      isEditable: true,
      placeholder: 'Email (optional)',
      isRequired: false
    },
    {
      key: 'extRole',
      name: 'extRole',
      value: 'VICTIM',
      label: 'Type',
      fieldType: INPUT_FIELD_TYPE.SELECT,
      options: [
        { key: 'VICTIM', value: 'VICTIM', label: 'Victim' },
        { key: 'SUSPECT', value: 'SUSPECT', label: 'Suspect' }
      ],
      isEditable: true
    }
  ]
};

export const transactionInvolvedFieldConfig = {
  selectedTransactionFields: (txn) => [
    {
      key: 'orderId',
      name: 'orderId',
      value: txn?.orderId || '',
      label: 'Transaction Id',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: 'sendAmount',
      name: 'sendAmount',
      value: txn?.amount?.amount,
      label: 'Send Amount',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.NUMBER,
      isEditable: false
    },
    {
      key: 'receiveAmount',
      name: 'receiveAmount',
      value: txn?.additionalDetails?.receiveAmount?.amount,
      label: 'Receive Amount',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.NUMBER,
      isEditable: false
    },
    {
      key: 'currencyFrom',
      name: 'currencyFrom',
      value: txn?.amount?.currency,
      label: 'From Currency',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: 'currencyTo',
      name: 'currencyTo',
      value: txn?.additionalDetails?.receiveAmount?.currency,
      label: 'To Currency',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: 'orderStatus',
      name: 'orderStatus',
      value: txn?.status,
      label: 'Status',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: 'orderType',
      name: 'orderType',
      value: txn?.product,
      label: 'Type',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: false
    },
    {
      key: 'reversalStatus',
      name: 'reversalStatus',
      value: null,
      label: 'Reversal Status',
      caption: null,
      fieldType: INPUT_FIELD_TYPE.SELECT,
      fieldSize: FIELD_SIZE.MEDIUM,
      placeholder: 'Select Reversal Status',
      options: CASE_INVESTIGATION_CREATE_ENUMS.REVERSAL_STATUS.map((o) => ({
        key: o.key,
        value: o.value,
        label: o.label
      })),
      isEditable: true,
      isRequired: true
    },
    {
      key: 'finalLossAmount',
      name: 'finalLossAmount',
      value: null,
      label: 'Final Loss Amount',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.NUMBER,
      isEditable: true,
      isRequired: true
    },
    {
      key: 'finalLossCurrency',
      name: 'finalLossCurrency',
      value: null,
      label: 'Final Loss Currency',
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      isEditable: true,
      isRequired: true
    }
  ]
};

export const investigatorNoteFieldConfig = (formData) => ({
  key: 'investigatorNote',
  name: 'investigatorNote',
  value: formData?.investigatorNote || '',
  label: 'Add Investigator Note',
  caption: null,
  placeholder: 'Enter your notes here...',
  fieldType: INPUT_FIELD_TYPE.TEXTAREA,
  fieldSize: FIELD_SIZE.LARGE,
  width: '100%',
  isEditable: true,
  isRequired: false,
  maxLength: 500
});
